'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _QuestionCircleOutlined = _interopRequireDefault(require('./lib/icons/QuestionCircleOutlined'));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _QuestionCircleOutlined;
  exports.default = _default;
  module.exports = _default;